import { render, staticRenderFns } from "./EditRootBrand.vue?vue&type=template&id=0f51b9b4&scoped=true"
import script from "./EditRootBrand.vue?vue&type=script&lang=js"
export * from "./EditRootBrand.vue?vue&type=script&lang=js"
import style0 from "./EditRootBrand.vue?vue&type=style&index=0&id=0f51b9b4&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f51b9b4",
  null
  
)

export default component.exports